"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bolognola": {
    "8dddc5fa": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "skipSearch": false
    }],
    "villa-bentivoglio": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f9bff77": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "skipSearch": false
    }],
    "villa-malvezzi": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "100f036f": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "skipSearch": false
    }],
    "villa-pedoli": [{
      "hkey": "60d8ab7a",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;